import { Stack as Stack$1 } from "../mantine-passthroughs/index.js";
import drawer_module_default from "./drawer.module.js";
import { Drawer, RemoveScroll } from "@mantine/core";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/drawer/Drawer.tsx
const Drawer$1 = ({ header, footer, onClose, opened, children, height, position = "right", fullWidth = false, size = "md", compact = false, "data-testid": testId }) => {
	const rootProps = {
		onClose,
		opened,
		classNames: drawer_module_default,
		position,
		size
	};
	if (fullWidth) rootProps.className = RemoveScroll.classNames.fullWidth;
	return /* @__PURE__ */ jsxs(Drawer.Root, {
		"data-compact": compact ? "true" : void 0,
		...rootProps,
		"data-position": position,
		children: [/* @__PURE__ */ jsx(Drawer.Overlay, {}), /* @__PURE__ */ jsx(Drawer.Content, {
			"data-testid": testId,
			h: height,
			mah: position === "bottom" || position === "top" ? "calc(100svh - 4rem)" : "100svh",
			children: /* @__PURE__ */ jsxs(Stack$1, {
				gap: 0,
				h: "100%",
				children: [
					/* @__PURE__ */ jsxs(Drawer.Header, { children: [header, /* @__PURE__ */ jsx(Drawer.CloseButton, {})] }),
					/* @__PURE__ */ jsx(Drawer.Body, {
						flex: 1,
						style: { overflow: "auto" },
						children
					}),
					footer
				]
			})
		})]
	});
};

//#endregion
export { Drawer$1 as Drawer };